import { render, staticRenderFns } from "./ProfileModuleSkeleton.vue?vue&type=template&id=ddcd03ac&scoped=true&"
import script from "./ProfileModuleSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProfileModuleSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProfileModuleSkeleton.vue?vue&type=style&index=0&id=ddcd03ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcd03ac",
  null
  
)

export default component.exports